const MobileMap = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.6875"
        y="0.6875"
        width="42.625"
        height="42.625"
        rx="21.3125"
        fill="#F3F3F3"
      />
      <rect
        x="0.6875"
        y="0.6875"
        width="42.625"
        height="42.625"
        rx="21.3125"
        stroke="#E8E9E9"
        strokeWidth="1.375"
      />
      <mask
        id="mask0_15474_61970"
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="34"
        height="34"
      >
        <rect x="5.5" y="5.5" width="33" height="33" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15474_61970)">
        <path
          d="M22 28.6405C24.4355 26.6953 26.2754 24.8263 27.5197 23.0333C28.7641 21.2403 29.3863 19.5338 29.3863 17.9137C29.3863 16.5322 29.1342 15.3588 28.63 14.3937C28.1258 13.4287 27.503 12.6445 26.7616 12.0414C26.0202 11.4383 25.2195 11.0008 24.3596 10.729C23.4996 10.4572 22.7134 10.3213 22.0008 10.3213C21.2883 10.3213 20.5018 10.4572 19.6413 10.729C18.7808 11.0008 17.9798 11.4383 17.2384 12.0414C16.497 12.6445 15.8742 13.4287 15.37 14.3937C14.8658 15.3588 14.6137 16.5322 14.6137 17.9137C14.6137 19.5338 15.2359 21.2403 16.4803 23.0333C17.7246 24.8263 19.5645 26.6953 22 28.6405ZM22 30.4068C21.8236 30.4068 21.6492 30.377 21.4768 30.3174C21.3044 30.2577 21.1456 30.1683 21.0005 30.049C19.1971 28.6375 17.3939 26.8862 15.5909 24.7949C13.7878 22.7036 12.8863 20.4099 12.8863 17.9137C12.8863 16.3774 13.1612 15.0303 13.7112 13.8727C14.2612 12.715 14.9722 11.743 15.8442 10.9568C16.7162 10.1706 17.6954 9.5802 18.7817 9.18562C19.868 8.79104 20.9406 8.59375 21.9996 8.59375C23.0585 8.59375 24.1313 8.79104 25.2178 9.18562C26.3045 9.5802 27.2838 10.1706 28.1558 10.9568C29.0278 11.743 29.7388 12.715 30.2888 13.8727C30.8388 15.0303 31.1137 16.3774 31.1137 17.9137C31.1137 20.4099 30.2122 22.7036 28.4092 24.7949C26.6061 26.8862 24.8029 28.6375 22.9995 30.049C22.8544 30.1683 22.6956 30.2577 22.5232 30.3174C22.3508 30.377 22.1764 30.4068 22 30.4068ZM22.0027 19.9463C22.6255 19.9463 23.1539 19.7284 23.5879 19.2926C24.0218 18.8568 24.2387 18.3276 24.2387 17.7048C24.2387 17.082 24.0209 16.5536 23.5851 16.1196C23.1493 15.6857 22.6201 15.4688 21.9973 15.4688C21.3745 15.4688 20.8461 15.6866 20.4122 16.1224C19.9782 16.5582 19.7613 17.0874 19.7613 17.7102C19.7613 18.333 19.9791 18.8614 20.4149 19.2953C20.8507 19.7293 21.3799 19.9463 22.0027 19.9463ZM13.75 35.4062C13.5053 35.4062 13.3001 35.323 13.1346 35.1565C12.969 34.9901 12.8863 34.7838 12.8863 34.5378C12.8863 34.2917 12.969 34.087 13.1346 33.9237C13.3001 33.7603 13.5053 33.6787 13.75 33.6787H30.25C30.4947 33.6787 30.6999 33.7619 30.8654 33.9283C31.031 34.0948 31.1137 34.301 31.1137 34.5471C31.1137 34.7931 31.031 34.9978 30.8654 35.1612C30.6999 35.3245 30.4947 35.4062 30.25 35.4062L13.75 35.4062Z"
          fill="#323941"
        />
      </g>
    </svg>
  );
};
export default MobileMap;
